import { AsmDashboardsViewId } from '../models/asm-dashboards-view-id';
import { AsmDashboardsType } from '../models/asm-dashboards-type';
import { TypeService, ViewService } from '@sol/components';

export function provideAsmDashboardsViews(viewService: ViewService, typeService: TypeService): void {
  typeService.addType(AsmDashboardsType.kpiSparkline);
  viewService.addView(
    AsmDashboardsType.kpiSparkline,
    'read',
    AsmDashboardsViewId.kpiSparkline,
    () =>
      import('../components/view/asm-view-read-kpi-sparkline/asm-view-read-kpi-sparkline.component').then(
        m => m.AsmViewReadKpiSparklineComponent,
      ),
    true,
  );
}
